import {useContext} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import {CustomerInterface} from "../../interfaces/customer/CustomerInterface";

export default function Account() {
    const [state, _] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const customer = state.customer as CustomerInterface;

    return (
        <div>
            <h1 className="bs-head">Мои данные</h1>

            <div className="box">
                {customer && <div className="box-body">
                    <div className="row">
                        <div className="col-md-12">
                            <h3>Общая информация</h3>
                            <dl className="row">
                                <dt className="col-sm-3">ID:</dt>
                                <dd className="col-sm-9">{customer.id}</dd>
                                <dt className="col-sm-3">Название:</dt>
                                <dd className="col-sm-9">{customer.name}</dd>
                                <dt className="col-sm-3">ИНН:</dt>
                                <dd className="col-sm-9">{customer.inn}</dd>
                                {customer.kpp && (
                                    <>
                                        <dt className="col-sm-3">КПП:</dt>
                                        <dd className="col-sm-9">{customer.kpp}</dd>
                                    </>
                                )}
                                <dt className="col-sm-3">Адрес:</dt>
                                <dd className="col-sm-9">{customer.address}</dd>
                                <dt className="col-sm-3">Склад:</dt>
                                <dd className="col-sm-9">{customer.stock_id}</dd>
                            </dl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <h3>Лицевые счета</h3>
                            {customer.accounts.map((account, index) => (
                                <dl className="row" key={account.id || index}>
                                    <dt className="col-sm-3">ID:</dt>
                                    <dd className="col-sm-9">{account.id}</dd>
                                    <dt className="col-sm-3">Название:</dt>
                                    <dd className="col-sm-9">{account.name}</dd>
                                    <dt className="col-sm-3">Менеджер:</dt>
                                    <dd className="col-sm-9">{account.manager.name}</dd>
                                    <dt className="col-sm-3">Телефон:</dt>
                                    <dd className="col-sm-9">{account.manager.phone_additional}</dd>
                                    <dt className="col-sm-3">E-mail:</dt>
                                    <dd className="col-sm-9">
                                        <a href={`mailto:${account.manager.email}`}>
                                            {account.manager.email}
                                        </a>
                                    </dd>
                                    <dt className="col-sm-3">Тип доставки:</dt>
                                    <dd className="col-sm-9">{account.ship_type}</dd>
                                </dl>
                            ))}
                        </div>
                        <div className="col-md-12">
                            <h3>Грузополучатели</h3>
                            {customer.consignees.map((consignee, index) => (
                                <dl className="row" key={consignee.id || index}>
                                    <dt className="col-sm-3">ID:</dt>
                                    <dd className="col-sm-9">{consignee.id}</dd>
                                    <dt className="col-sm-3">Название:</dt>
                                    <dd className="col-sm-9">{consignee.name}</dd>
                                    <dt className="col-sm-3">Адрес:</dt>
                                    <dd className="col-sm-9">{consignee.address}</dd>
                                </dl>
                            ))}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <h3>Менеджеры</h3>
                            {customer.customer_managers.map((manager, index) => (
                                <dl className="row" key={manager.id || index}>
                                    <dt className="col-sm-3">ID:</dt>
                                    <dd className="col-sm-9">{manager.id}</dd>
                                    <dt className="col-sm-3">ФИО:</dt>
                                    <dd className="col-sm-9">{manager.name}</dd>
                                    <dt className="col-sm-3">Email:</dt>
                                    <dd className="col-sm-9">{manager.email}</dd>
                                    <dt className="col-sm-3">Телефон:</dt>
                                    <dd className="col-sm-9">{manager.phone}</dd>
                                </dl>
                            ))}
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    );
}